/* eslint-disable max-len */
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnInit,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { TopHeaderService } from 'src/app/core/services/top-header/top-header.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { WINDOW } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-coupon-card-vip',
  templateUrl: './coupon-card-vip.component.html',
  styleUrls: ['./coupon-card-vip.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Coupon VIP card
 */
export class CouponCardVipComponent implements OnInit, AfterViewInit {
  @Input() businessName!: string;
  @Input() resellerName!: string;
  @Input() vipLevel!: string;
  @Input() familyName!: string;
  @Input() discountValue!: number;
  @Input() couponCode!: string;
  @Input() startingDate!: string;
  @Input() expirationDate!: string;
  @Input() active?: boolean;
  @Input() business!: any;
  @Input() printers!: any;
  @Input() countryName!: any;
  @Input() configSeriesDisclaimer?: string;
  readonly activeText = 'coupon-expires-on';
  readonly expiredText = 'coupon-expired-on';
  models!: any;
  language = '';
  uniqueModel!: any;

  @Input() businessImgBase64?: string;
  /**
   * @constructor
   */
  constructor(
    public translationService: TranslationService,
    public topHeaderService: TopHeaderService,
    private elRef: ElementRef,
    private renderer: Renderer2,
    @Inject(WINDOW) private window: Window
  ) {}

  /**
   * on init
   */
  ngOnInit() {
    this.language = this.translationService.getActiveLang();
    this.findModel();
  }

  /**
   * afterviewinit
   * If the business does not have image, replace by a svg image corresponding to account_circle mat-icon
   * This replacement is necessary because mat-icon does not work with html-to-image library
   */
  ngAfterViewInit(): void {
    const cardElement: HTMLElement = this.elRef.nativeElement;
    const appRoundedImageElement =
      cardElement.querySelector('app-rounded-image');
    const matIconElement = cardElement.querySelector('mat-icon');
    if (this.business.imgSource === '') {
      const parent = appRoundedImageElement!.parentNode;
      this.renderer.removeChild(parent, matIconElement);

      const imgElement = document.createElement('img');
      imgElement.src = this.convertMatIconToBase64();

      matIconElement!.replaceWith(imgElement);
    }
  }

  /**
   * Check card footer status
   */
  get statusCheck() {
    if (this.active) {
      return this.activeText;
    }
    return this.expiredText;
  }

  /**
   * Convert icon to Base64
   * @return {string}
   */
  private convertMatIconToBase64(): string {
    const svgString = `
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
      <path d="M0 0h24v24H0z" fill="none"/>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" fill="#002775"/>
    </svg>
    `;

    const base64Image =
      'data:image/svg+xml;base64,' + this.window.btoa(svgString);
    return base64Image;
  }

  /**
   * Find Model that has discount
   */
  findModel(): void {
    this.uniqueModel = 'SERIES-' + this.familyName + ' INK';
  }
}
